document.addEventListener('DOMContentLoaded', function(){
  // for JINS × Kryskhloe page
  if ($(".kryskhloe-item")[0]){
    $(window).scroll(function () {
      if ( ($(window).scrollTop() >= 0) && ($(window).scrollTop() < 60) ) {
        $('.kryskhloe-item').removeClass('active').css('opacity', '0');
        $('.kryskhloe-item:first-child').addClass('active').css('opacity', '1');
      } else if ( ($(window).scrollTop() >= 60) && ($(window).scrollTop() < 120) ) { 
        $('.kryskhloe-item').removeClass('active').css('opacity', '0');
        $('.kryskhloe-item:nth-child(2)').addClass('active').css('opacity', '1');
      } else if ( ($(window).scrollTop() >= 120) && ($(window).scrollTop() < 210) ) {
        $('.kryskhloe-item').removeClass('active').css('opacity', '0');
        $('.kryskhloe-item:nth-child(3)').addClass('active').css('opacity', '1');
      }else{
        $('.kryskhloe-item').removeClass('active').css('opacity', '0');
        $('.kryskhloe-item:last-child').addClass('active').css('opacity', '1');
      }
    });
  }
});